import { PumpSalary } from 'pages/Employees';
import { TransportOverRateMixer } from 'pages/TransportOverRateMixer';

import {
  EmployeesDetail,
  EmployeesList,
  EmployeesReport,
  EmployeesReportWork,
  EmployeesRoles,
  EmployeesSalary,
  Posts,
  Roles,
  RolesDetails,
  TransportOverRate,
} from '../../pages';

export const routingEmployees = [
  {
    path: '/role',
    exact: true,
    component: Roles,
    claims: ['CanEditEmployees'],
  },
  {
    path: '/role/:id',
    exact: true,
    component: RolesDetails,
    claims: ['CanEditEmployees'],
  },
  {
    path: '/role-add/',
    exact: true,
    component: RolesDetails,
    claims: ['CanEditEmployees'],
  },
  {
    path: '/post',
    exact: true,
    component: Posts,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/employee',
    exact: true,
    component: EmployeesList,
    claims: ['CanLookEmployeeSection'],
  },
  {
    path: '/employee-roles',
    exact: true,
    component: EmployeesRoles,
    claims: ['all'],
  },
  {
    path: '/employee/detail/:id',
    exact: true,
    component: EmployeesDetail,
    claims: ['CanEditEmployees'],
  },
  {
    path: '/employee/add',
    exact: true,
    component: EmployeesDetail,
    claims: ['CanEditEmployees'],
  },
  {
    path: '/employee-report',
    exact: true,
    component: EmployeesReport,
    claims: ['all'],
  },
  {
    path: 'employee-report-add',
    exact: true,
    component: EmployeesReport,
    claims: ['all'],
  },
  {
    path: '/employee-salary',
    exact: true,
    component: EmployeesSalary,
    claims: ['CanLookSalaryFixedConfigurationSection'],
  },
  {
    path: '/pump-salary',
    exact: true,
    component: PumpSalary,
    claims: ['CanLookDriverMixerSalaryConfiguration'],
  },
  {
    path: '/employees-report-work',
    exact: true,
    component: EmployeesReportWork,
    claims: ['CanSeeOperatingSchedule'],
  },
  {
    path: '/TransportOverRate',
    exact: true,
    component: TransportOverRate,
    claims: ['CanLookTransportOverRateSection'],
  },
  {
    path: '/TransportOverRateMixer',
    exact: true,
    component: TransportOverRateMixer,
    claims: ['CanLookTransportOverRateSection'],
  },
];
